import React, { useState } from 'react';
import { getSmoothStepPath } from 'reactflow';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  SwapHoriz as SwapIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  label
}) => {
  const [contextMenu, setContextMenu] = useState(null);

  // Calculate edge path
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Calculate label position on the actual path (not straight line)
  // Create a temporary path element to measure the real path
  const tempPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  tempPath.setAttribute('d', edgePath);
  const pathLength = tempPath.getTotalLength();
  const midPoint = tempPath.getPointAtLength(pathLength / 2);

  const labelX = midPoint.x;
  const labelY = midPoint.y;


  const handleContextMenu = (event) => {
    // Don't show context menu if map is locked
    if (data?.isLocked) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    setContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY
    });
  };

  const handleCloseMenu = () => {
    setContextMenu(null);
  };

  const handleSwapDirection = async () => {
    console.log('Swapping direction, connection_id:', data?.connection_id);

    try {
      const response = await fetch(`/api/connections/${data.connection_id}/swap`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      });

      if (response.ok) {
        console.log('Connection direction swapped successfully');
        if (data.onReload) {
          data.onReload();
        }
      } else {
        const errorText = await response.text();
        console.error('Failed to swap direction:', response.status, errorText);
        alert(`Ошибка смены направления: ${response.status}`);
      }
    } catch (error) {
      console.error('Error swapping connection:', error);
      alert('Ошибка при смене направления');
    }

    handleCloseMenu();
  };

  const handleDeleteConnection = async () => {
    if (!window.confirm('Удалить это подключение?')) {
      handleCloseMenu();
      return;
    }

    try {
      const response = await fetch(`/api/connections/${data.connection_id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      });

      if (response.ok) {
        console.log('Connection deleted');
        if (data.onReload) {
          data.onReload();
        }
      }
    } catch (error) {
      console.error('Error deleting connection:', error);
    }

    handleCloseMenu();
  };

  return (
    <>
      {/* Main edge path */}
      <path
        id={id}
        d={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          fill: 'none',
          pointerEvents: 'none'
        }}
      />

      {/* Invisible wider path for easier interaction */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={10}
        style={{
          cursor: data?.isLocked ? 'default' : 'context-menu',
          pointerEvents: data?.isLocked ? 'none' : 'all'
        }}
        onContextMenu={handleContextMenu}
      />

      {label && (
        <>
          {/* Background rectangle for label */}
          <rect
            x={labelX - 30}
            y={labelY - 12}
            width={60}
            height={24}
            fill="white"
            stroke="#999"
            strokeWidth={1}
            rx={4}
            ry={4}
            style={{ pointerEvents: 'none' }}
          />
          {/* Label text */}
          <text
            x={labelX}
            y={labelY + 4}
            textAnchor="middle"
            style={{
              fontSize: 12,
              fontWeight: 600,
              fill: '#333',
              pointerEvents: 'none',
              userSelect: 'none'
            }}
          >
            {label}
          </text>
        </>
      )}

      {/* Context menu */}
      <Menu
        open={contextMenu !== null}
        onClose={handleCloseMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={handleSwapDirection}>
          <ListItemIcon>
            <SwapIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Поменять направление</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleDeleteConnection}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Удалить подключение</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CustomEdge;
